import { graphql } from '@/gql';
import type { CreditUsageQueryVariables } from '@/gql/graphql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { PaginatedCreditUsageTypeResponse } from '@/models/payment';

export const fetchCreditUsage = async ({
  phoneNumber,
  partnerCode,
  pagination,
}: CreditUsageQueryVariables): Promise<PaginatedCreditUsageTypeResponse> => {
  const response = await queryExecute({
    query: graphql(`
      query CreditUsage($phoneNumber: String!, $partnerCode: String, $pagination: PaginationInputType) {
        creditUsage(phoneNumber: $phoneNumber, partnerCode: $partnerCode, pagination: $pagination) {
          count
          rows {
            transactionId
            createdAt
            category
            amount
            currency
            description
            notes
            associatedObjectId
            associatedObjectType
          }
        }
      }
    `),
    variables: {
      phoneNumber,
      partnerCode,
      pagination,
    },
    fetchPolicy: 'no-cache',
  });

  return response.data.creditUsage;
};
